import React from 'react';

// components
import ErrorBoundary from 'layout/components/ErrorBoundary';

// styles
import * as Styled from 'eCoach/_styles/NavRow.style';

export default function NavRow({
  heading,
  onClickAction,
  subheading,
  icon,
  isActive,
  isSelected = false,
}: {
  heading: string;
  onClickAction: () => void;
  subheading: string | React.ReactNode;
  icon?: React.ReactNode;
  isActive: boolean;
  isSelected?: boolean;
}): JSX.Element {
  return (
    <ErrorBoundary>
      <Styled.Row onClick={onClickAction} isActive={isActive}>
        <Styled.Item isActive={isActive} isSelected={isSelected}>
          <Styled.IconContainer>
            {icon}
            <Styled.TextContent>
              <Styled.Heading>{heading}</Styled.Heading>
              <Styled.Subheading>{subheading}</Styled.Subheading>
            </Styled.TextContent>
          </Styled.IconContainer>
        </Styled.Item>
      </Styled.Row>
    </ErrorBoundary>
  );
}
